
import { namespace } from 'vuex-class';

import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { RequestStatus } from '@/modules/trade/store/trade';

import { isImpersonate } from '@/modules/common/services/partner';
import {
  RoundedIcon,
  Row,
  InitialAvatarIcon,
  ChipStatus
} from '@warrenbrasil/nebraska-web';
import { HelpButton } from '@/modules/trade/components/HelpButton';
import { Feature } from '@/modules/common/components/Feature';
import { FeatureFlags } from '@/types/models/FeatureFlags';
import { FeatureFlagsModule } from '@/modules/common/store/FeatureFlagsModule';
import { FooterButton } from './components/FooterButton';
import {
  AccountStatus,
  HomeBrokerStatus
} from '@/modules/trade/services/account';

const tradePositionsModule = namespace('tradeModule');

@Component({
  components: {
    RoundedIcon,
    Row,
    Feature,
    HelpButton,
    FooterButton,
    InitialAvatarIcon,
    ChipStatus
  }
})
export default class GeneralFooter extends Vue {
  public isImpersonated = isImpersonate() ?? false;

  readonly RequestStatus = RequestStatus;

  @Prop({ type: Boolean, required: true })
  readonly hasRequestTradeMap!: boolean;

  @Prop({ type: String, required: true })
  readonly tradeMapTitle!: string;

  @Prop({ type: Boolean, required: true })
  readonly homeBrokerButtonEnable!: boolean;

  @Prop({ type: Object, default: null })
  readonly homeBrokerStatus?: HomeBrokerStatus | null;

  @Prop({ type: Object, required: false })
  readonly tradeStatus?: AccountStatus;

  @tradePositionsModule.State('accountStatusRequestStatus')
  readonly accountStatusRequestStatus!: RequestStatus;

  @Emit('request-trade-map')
  public requestTradeMapAction() {}

  @Emit('enter-home-broker')
  public onAccessHomeBrokerClick() {}

  @Emit('request-home-broker')
  public requestBrokerAction() {}

  @Emit('security-click')
  public goToSecurity() {}

  @Emit('track-account')
  public trackAccountStatements() {}

  @Emit('help-click')
  public emitHelpClick() {}

  get NebraskaColors() {
    return NebraskaColors;
  }

  get isRLPEnabled() {
    return !!this.tradeStatus?.isRLPEnabled;
  }

  get hasUnifiedAccountEnabled() {
    return FeatureFlagsModule.isEnabled(FeatureFlags.UNIFIED_ACCOUNT);
  }

  get isFinOneIntegrationWithTradeV0Enabled() {
    return FeatureFlagsModule.isEnabled(
      FeatureFlags.ENABLE_FIN_ONE_INTEGRATION_WITH_TRADE_V0
    );
  }

  get shouldShowRLPPage() {
    return FeatureFlagsModule.isEnabled(FeatureFlags.SHOW_RLP_PAGE);
  }

  get isBrokerageFeeOnCostsPageEnabled() {
    return FeatureFlagsModule.isEnabled(
      FeatureFlags.ENABLE_BROKERAGE_FEE_ON_COSTS_PAGE
    );
  }

  get homeBrokerButtonText() {
    return this.homeBrokerStatus?.buttonText ?? '';
  }

  get hasFailedAccountStatusRequest() {
    return this.accountStatusRequestStatus === RequestStatus.Error;
  }

  get isHomeBrokerButtonEnabled() {
    return this.homeBrokerButtonEnable && !this.hasFailedAccountStatusRequest;
  }

  get showButtonHomeBroker() {
    return FeatureFlagsModule.isEnabled(FeatureFlags.WARREN_HOME_BROKER);
  }

  get shouldRequestBroker() {
    return FeatureFlagsModule.isEnabled(FeatureFlags.TRADE_REQUEST_BROKER);
  }

  get enabledMFA() {
    return this.tradeStatus?.enabledMFA;
  }

  get enabledMFATradeMapButton() {
    return this.hasFailedAccountStatusRequest || this.enabledMFA;
  }

  get showDynamicAccessBrokerButton() {
    return (
      this.shouldRequestBroker &&
      this.tradeStatus &&
      this.tradeStatus.enabledMFA &&
      !this.isImpersonated
    );
  }

  get computedHomeBrokerText() {
    return this.hasFailedAccountStatusRequest
      ? 'Serviço indisponível no momento'
      : 'Cadastre a verificação em duas etapas';
  }

  get computedTradeMapSubText() {
    return this.hasFailedAccountStatusRequest
      ? 'Serviço indisponível no momento'
      : '';
  }

  get computedHomeBrokerStyle() {
    return {
      color: this.homeBrokerButtonEnable
        ? NebraskaColors.textPrimary
        : NebraskaColors.textSecondary
    };
  }

  get shouldShowMFABroker() {
    const shouldRenderHomeBrokerButton =
      (this.showButtonHomeBroker || this.shouldRequestBroker) &&
      this.tradeStatus &&
      !this.enabledMFA;
    return this.hasFailedAccountStatusRequest || shouldRenderHomeBrokerButton;
  }

  get FeatureFlags() {
    return FeatureFlags;
  }
}
